import React, { useState } from "react";
import "./Favorites.css";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import Alert from "../../../Components/Alert/Alert";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import ShopCard from "../../../Components/ShopCard/ShopCard";
import useFavorites from "../../../Hooks/useFavorites";
import { useNavigate } from "react-router-dom";
import { useBaseUrl } from "../../../ApiContext";

export default function Favorites() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl()
  const { userToken } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const { favorites, setFavorites } = useFavorites(
    userToken,
    setShowAlert,
    setAlertText
  );
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleProductClick = (baseProductId, productId) => {
    navigate("/product", {
      state: { baseId: baseProductId, productId: productId },
    });
  };

  const handleRemoveFavorite = async (productId) => {
    try {
      const response = await Axios.post(
        `${baseUrl}/favorite/add_item`,
        { id: productId, quantity: 0 },
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      console.log(response.data);
      const newFavorites = favorites.filter(
        (favorite) => favorite.product.id !== productId
      );
      setFavorites(newFavorites);
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 2000);
      setAlertText("از علاقه مندی ها حذف شد");
    } catch (error) {
      console.log("Error during adding to favorites", error);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="pageTitle partialProductsHeading">علاقه مندی ها</h3>
          <div className="favoritesProducts scroll centeredFlex">
            {favorites.length > 0 &&
              favorites.map((item) => (
                <ShopCard
                  key={item.id}
                  label="favorites"
                  {...item.product}
                  onShopCardClick={() =>
                    handleProductClick(
                      item.product.base_product_id,
                      item.product.id
                    )
                  }
                  onFavoriteRemove={() => handleRemoveFavorite(item.product.id)}
                />
              ))}
          </div>
          <Alert showAlert={showAlert} alertText={alertText} bottom="6rem" />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
